"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var paralax_1 = __importDefault(require("@/helper/paralax"));
var PARALAX_VALUE = 50;
var Hero = (function () {
    function Hero(el) {
        if (el) {
            this.element = el;
            document.addEventListener("scroll", this.onScroll.bind(this), false);
            this.onScroll();
        }
    }
    Hero.prototype.onScroll = function () {
        if (!this.element)
            return;
        var rect = this.element.getBoundingClientRect();
        var paralax = (0, paralax_1.default)(window.scrollY, rect);
        this.element && (this.element.style.transform = "translateY(".concat(paralax * PARALAX_VALUE, "%)"));
    };
    return Hero;
}());
exports.default = Hero;
